import MetricDashCard from "../../../../../components/dash-card/metric-dash-card.jsx";

export default function OnlineUsersCard({ onlineUsers }) {
    return (
        <article className="col-start-1 row-start-1 min-h-0 h-full flex items-center justify-center">
            <MetricDashCard
                counterCard
                title="Usuários online"
                value={onlineUsers?.online ?? 0}
                colSpan={6}
                width="auto"
                height="auto"
                dashClassName="min-w-[140px] min-h-[80px]"
            />
        </article>
    )
}
